import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { PropertyTypesResource } from "api/resource/property-types";
import { loginReset } from "redux/slice/authentication";

export interface PropertyTypesState {
    loading?: boolean;
    error?: string | null;
    propertyTypes?: PropertyTypesResource;
}

const initialState: PropertyTypesState = {
    loading: false,
};

export const fetchPropertyTypes = createAsyncThunk("propertyTypes/fetch", async (_, thunkAPI) => {
    thunkAPI.dispatch(propertyTypesLoading());
    const result = api.getPropertyTypes();
    result
        .then((s) => thunkAPI.dispatch(propertyTypesLoaded(s)))
        .catch((e) => thunkAPI.dispatch(propertyTypesFailed(e)));
    return result;
});

export const savePropertyTypes = createAsyncThunk("propertyTypes/save", async (payload: PropertyTypesResource, thunkAPI) => {
    thunkAPI.dispatch(propertyTypesLoading());
    const result = api.updatePropertyTypes(payload);
    result
        .then((s) => thunkAPI.dispatch(propertyTypesLoaded(s)))
        .catch((e) => thunkAPI.dispatch(propertyTypesFailed(e)));
    return result;
});

export const restorePropertyTypes = createAsyncThunk("propertyTypes/restore", async (_, thunkAPI) => {
    thunkAPI.dispatch(propertyTypesLoading());
    const result = api.restorePropertyTypes();
    result
        .then((s) => thunkAPI.dispatch(propertyTypesLoaded(s)))
        .catch((e) => thunkAPI.dispatch(propertyTypesFailed(e)));
    return result;
});

export const propertyTypesSlice = createSlice({
    name: "propertyTypes",
    initialState,
    reducers: {
        propertyTypesLoading: (state) => {
            state.loading = true;
        },
        propertyTypesLoaded: (state, action: PayloadAction<PropertyTypesResource>) => {
            state.loading = false;
            state.error = null;
            state.propertyTypes = action.payload;
        },
        propertyTypesFailed: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.message;
        },
        default: (state) => {
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(loginReset, () => {
            return initialState;
        });
    },
});

export const { propertyTypesLoading, propertyTypesLoaded, propertyTypesFailed } = propertyTypesSlice.actions;
